import { Component, Input, OnInit } from '@angular/core';
import { RATINGS } from 'src/app/core/enums';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss']
})
export class RatingComponent implements OnInit {
  @Input() rate: string;

  RATINGS = RATINGS;

  constructor() { }

  ngOnInit(): void {
  }

}
